import PortfolioImage from '../assets/images/portofolio1.png'
import KalanguImage from '../assets/images/kalangu.png'
import AshBusImage from '../assets/images/AshBus.png'

const projects = [
    {
        image: KalanguImage,
        name: 'Ashesi Kalangu',
        description: 'A web application (this project)  which showcases the portfolio of Daniel Nettey to potential recruiters and others to get to know more about the frontend developer.',
        demo: 'https://kalangu.ashesi.edu.gh/',
        github: '',
        resources: ['React', 'Styled Components', 'TailWind CSS', 'ReactQuery', 'REST APIs', 'AWS Amplify']
    },
    {
        image: AshBusImage,
        name: 'AshBus Project',
        description: 'A web application (this project)  which showcases the portfolio of Daniel Nettey to potential recruiters and others to get to know more about the frontend developer.',
        demo: 'http://dan3.pythonanywhere.com/',
        github: 'https://github.com/danielonettey/Ashbus_web-2.0',
        resources: ['React', 'Django', 'SQL', 'PythonAnywhere', 'REST APIs']
    },
    {
        image: PortfolioImage,
        name: 'Portfolio Project',
        description: 'A web application (this project)  which showcases the portfolio of Daniel Nettey to potential recruiters and others to get to know more about the frontend developer.',
        demo: '#',
        github: 'https://github.com/danielonettey/Portfolio',
        resources: ['React', 'Styled Components', 'TailWind CSS', '']
    }
]

export default projects